import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StocksModel } from '../models/stocks.model';
import { StocksService } from '../stocks.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { UomService } from '../../../uom/uom.service';
import { StockCategoryService } from '../../../stock-category/stock-category.service';
@Component({
  selector: 'app-stocks-edit',
  templateUrl: './stocks-edit.component.html',
  styleUrls: ['./stocks-edit.component.scss'],
  standalone: false
})
export class StocksEditComponent {

  title: string = "New Stock Item";
  editForm: FormGroup;
  stockInfo: StocksModel = {};
  isFormDirty: boolean = false;
  selectedBaseUom: any;
  uom_id: any;
  stock_item_category_id: any;
  selectedCategory: any;

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private stockService: StocksService,
    private uomService: UomService,
    private categoryService: StockCategoryService,
    private snackBarService: SnackBarService,
    public dialog: MatDialog,) {

    let stockId = this.route.snapshot.paramMap.get('id');
    this.editForm = this.builder.group({
      code: this.builder.control(this.stockInfo.code, [Validators.required, Validators.maxLength(10)]),
      name: this.builder.control(this.stockInfo.name, [Validators.required, Validators.maxLength(50)]),
      description: this.builder.control(this.stockInfo.description),
      uom_id: this.builder.control(this.stockInfo.uom_id), // Add this line
      stock_item_category_id: this.builder.control(this.stockInfo.stock_item_category_id), // Add this line
      is_sellable: this.builder.control(this.stockInfo.is_sellable), // Add this line
      is_manufactured: this.builder.control(this.stockInfo.is_manufactured), // Add this line




    });

    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });

    if (stockId !== null && parseInt(stockId) !== 0) {
      this.setstockInfo(stockId);
    }
  }
  ngOnInit(): void {
    //  this.loadRating(); 
    this.loadUomList();
    this.loadCategoryList();
  }

  /**
   * Dirtyness check
   * @returns 
   */
  isDirty(): boolean {
    return this.isFormDirty;
  }

  /**
   * checks the form is edited
   */
  navBack(): void {

    this.router.navigate(['/product/stocks']);

  }

  /**
   * If tas is is null set an empty area info
   * if area id is not null call api to rtrive the info
   * @param areaId 
   */
  setstockInfo(areaId: any): void {

    let response = this.stockService.getStockById(areaId).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.stockInfo = response.data.stocks;
          this.editForm.patchValue(this.stockInfo);
          this.title = this.getTitle();
          this.isFormDirty = false;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to get data from server. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }

  /**
   * 
   * @returns  the title for the dialog
   * sine the same dialog is used for edit and new, dynamically decide the title
   */
  getTitle(): string {
    let title = (this.stockInfo.id == 0) ? "New Stock Item" : "Editing : " + this.stockInfo.name;
    return title;
  }
  loadUomList(): void {
    let requestData = {
      search: {
        filters: {
          column: [],
          scope: { limit: 100, offset: 0 },
        },
        sort: [{ column: "code", order: "asc" }],
      },
    };

    this.uomService.getBaseUomList(requestData).subscribe(
      (response: {
        status: string;
        data: {
          uoms: any;
          code: any[];
          name: any;
          base_uom_id: any[];
        };
        message: any;
      }) => {
        if (response.status === "SUCCESS") {
          this.uom_id = response.data.uoms;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: "Failed!!!",
            type: "error",
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      }
    );
  }
  // loadCategoryList(): void {
  //   let requestData = {
  //     search: {
  //       filters: {
  //         column: [],
  //         scope: { limit: 100, offset: 0 },
  //       },
  //       sort: [{ column: "name", order: "asc" }],
  //     },
  //   };

  //   this.stockService.getList(requestData).subscribe(
  //     (response: {
  //       status: string;
  //       data: {
  //        category:any;

  //       };
  //       message: any;
  //     }) => {
  //       if (response.status === "SUCCESS") {
  //         this.stock_item_category_id = response.data.category;
  //       } else {
  //         let snackBarData: SnackBarData = {
  //           message: response.message,
  //           title: "Failed!!!",
  //           type: "error",
  //         };
  //         this.snackBarService.openSnackBar(snackBarData);
  //       }
  //     }
  //   );
  // }
  loadCategoryList(): void {
    let requestData = {
      search: {
        filters: {
          column: [],
          scope: { limit: 100, offset: 0 },
        },
        sort: [{ column: "code", order: "asc" }],
      },
    };

    this.stockService.getList(requestData).subscribe(
      (response: {
        status: string;
        data: {
          category: any;

        };
        message: any;
      }) => {
        if (response.status === "SUCCESS") {
          this.stock_item_category_id = response.data.category;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: "Failed!!!",
            type: "error",
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      }
    );
  }
  /**
     * On save
     * if the details are valid call the api to update the changes.
     */
  save(): void {

    if (this.editForm.valid) {
      this.editForm.markAllAsTouched();
      Object.assign(this.stockInfo, this.editForm.value);
      this.stockService.update(this.stockInfo).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            // handle success
            this.isFormDirty = false;
            let snckBarData: SnackBarData = {
              type: 'success',
              title: 'Saved',
              message: 'The record for ' + this.stockInfo.name + " has been updated succesfully."
            }
            this.snackBarService.openSnackBar(snckBarData);
          } else {
            let snackBarData: SnackBarData = {
              message: response.message,
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        },
        error: (error) => {
          // handle error
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });

    } else {
      this.editForm.markAllAsTouched();
    }
  }

}
